export const memberStyles = {
  control: (base) => ({
    ...base,
    width: "20.625rem",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};
